import { css } from 'linaria';

export const kitchenSignSectionPanelWrapper = css`
  width: 100%;
`;

export const kitchenSignSectionPanel = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0;

  @media (--only-mobile) {
    display: none;
  }
`;

export const kitchenSignSectionPanelIcon = css`
  margin-right: 34px;
  @media (--to-desktop) {
    display: none;
  }
`;

export const kitchenSignSectionPanelText = css`
  @media (--to-desktop) {
    display: none;
  }
`;

export const kitchenSignSectionPanelButtons = css`
  display: flex;
  margin-left: auto;
  column-gap: 24px;

  @media (--to-desktop) {
    && a {
      padding: 10px 20px;
    }
  }
`;

export const kitchenSignSectionPanelMobileButton = css`
  @media (--from-tablet) {
    display: none;
  }
`;
